import QuickLeaguesNavigationImpl from './quick-leagues-navigation.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIControllerView = MojitoCore.Presentation.UIControllerView;

/**
 * Quick leagues navigation view. Only supports leagues with match events.
 *
 * @class QuickLeaguesNavigation
 * @memberof Mojito.Modules
 */

/**
 * QuickLeaguesNavigation prop types.
 *
 * @property {string} sportId - Sport id.
 * @property {string} sportClassId - The id of a sport class. Will be used to load and present types (leagues) which belongs to it.
 * @property {string} [selectedTypeId] - The id of selected type (league, competition). Can be used to highlight item in a list.
 * @property {Function} [onItemClick = () => {}] - Callback triggered once league item clicked.
 */
const propTypes = {
    sportClassId: PropTypes.string.isRequired,
    sportId: PropTypes.string.isRequired,
    selectedTypeId: PropTypes.string,
    onItemClick: PropTypes.func,
};

const defaultProps = {
    onItemClick: noop,
};

export default UIControllerView(
    'QuickLeaguesNavigation',
    QuickLeaguesNavigationImpl,
    propTypes,
    defaultProps
);
